<template>
  <default>
    <div class="tw-w-full">
      <bread-crumb :breadcrumbs="breadcrumbs" />
    </div>
    <div>
      <v-card class="tw-mt-5 md:tw-mt-8 tw-px-4 md:tw-px-16 tw-py-1 md:tw-py-1">
        <div class="tw-flex tw-flex-row tw-justify-between">
          <div class="tw-w-32">
            <v-select
                v-model="filter"
                :items="items"
                label="Filter"
            ></v-select>
          </div>
          <v-icon title="refresh" class="tw-cursor-pointer" @click="getNotifications()">mdi-refresh</v-icon>
        </div>
        <div v-if="!loading">
          <v-simple-table v-if="notifications.length > 0" class="tw-pb-10">
            <template v-slot:default>
              <transition-group
                  tag="tbody"
                  name="fade"
                  mode="out-in"
                  appear
                  :duration="500">
                <tr
                    :class="['tw-cursor-pointer fruit-table-item',n.read ? '' : 'tw-bg-blue-100']"
                    v-for="n in notifications"
                    :key="n.notificationId"
                    @click="handleNotification(n)"
                >
                  <td class="c-gray-text tw-hidden md:tw-table-cell tw-capitalize">{{ title(n.notificationEnum) }}</td>
                  <td>
                    <p class="c-gray-text tw-block md:tw-hidden">{{ title(n.notificationEnum) }}</p>
                    <span class="tw-font-bold tw-capitalize">{{ n.notificationEnum.replace('_', ' ').toLowerCase() }}</span>
                    <br>
                    {{ n.message }}
                  </td>
                  <td class="c-gray-text tw-font-bold">
                    <time-ago :datetime="n.createdAt" :auto-update="60"></time-ago>
                  </td>
                  <td :class="['tw-border-r-4', n.read ? 'tw-border-gray-500' : 'tw-border-blue-500']" @click="handleNotification(n)"><a href="#">View
                    {{ title(n.notificationEnum) }} <v-icon color="primary">mdi-chevron-right</v-icon></a></td>
                </tr>
              </transition-group>
            </template>
          </v-simple-table>
          <div v-else class="tw-w-full tw-text-center tw-py-5">
            <p>No notifications found !</p>
          </div>
        </div>
        <div v-else class="tw-w-full tw-flex tw-justify-center tw-pb-10">
          <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
          ></v-progress-circular>
        </div>

        <infinite-loading v-if="!loading" @infinite="infiniteHandler">
          <div slot="spinner">
            <div class="tw-w-full tw-flex tw-justify-center tw-pb-10">
              <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
              ></v-progress-circular>
            </div>
          </div>
          <div slot="no-more" class="c-gray-text tw-py-6">That's all you got today !</div>
          <div slot="no-results"></div>
        </infinite-loading>

      </v-card>
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import axios from 'axios';
import { mapGetters } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'Notifications',
  components: { BreadCrumb, Default, InfiniteLoading },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Notifications',
          disabled: true,
          to: { name: 'Notifications' },
        }],
      items: ['All', 'Read', 'Unread'],
      loading: true,
      notifications: [],
      AllNotifications: [],
      filter: '',
      page: 1,
      pages: 0,
      perPage: 20,
    };
  },
  computed: {
    ...mapGetters('auth', ['authenticatedUser']),
  },
  watch: {
    filter(val) {
      if (val === 'All') {
        this.notifications = this.AllNotifications;
      } else if (val === 'Read') {
        this.notifications = this.AllNotifications.filter((n) => n.read === true);
      } else if (val === 'Unread') {
        this.notifications = this.AllNotifications.filter((n) => n.read === false);
      }
    },
  },
  mounted() {
    this.getNotifications(1).then(() => {
      this.loading = false;
    });
  },
  methods: {
    getNotifications(page) {
      return axios.get(`/customer/notification/app/all/pages/${this.authenticatedUser.email}?pin=${this.authenticatedUser['custom:kra-pin']}&productGroup=MOTOR&page=${page}&size=${this.perPage}`)
        .then((response) => {
          const { data, results } = JSON.parse(response.data);
          this.notifications = this.notifications.concat(data);
          this.AllNotifications = this.AllNotifications.concat(data);
          this.page += 1;
          this.pages = results;
        });
    },
    infiniteHandler($state) {
      if (Math.ceil((this.pages / this.perPage)) >= this.page) {
        this.getNotifications(this.page).then(() => {
          $state.loaded();
        });
      } else {
        $state.complete();
      }
    },
    title(type) {
      let title = '';
      if (type === 'RESUME_QUOTE') {
        title = 'Quote';
      } else if (type === 'BIRTHDAY') {
        title = 'Birthday';
      } else {
        title = 'Policy';
      }
      return title;
    },
    async handleNotification(n) {
      let data = { name: 'Notification' };
      if (n.notificationEnum === 'RESUME_QUOTE') data = { name: 'SavedQuotes' };
      if (n.notificationEnum === 'PREMIUM_DUE') data = { name: 'SinglePolicy', params: { policyNo: n.policyNumber } };
      if (n.notificationEnum === 'RENEWAL') data = { name: 'SinglePolicy', params: { policyNo: n.policyNumber } };
      if (n.notificationEnum === 'CERTIFICATE_READY') data = { name: 'SinglePolicy', params: { policyNo: n.policyNumber } };
      if (n.notificationEnum === 'PREMIUM_RECEIVED') data = { name: 'SinglePolicy', params: { policyNo: n.policyNumber } };
      if (n.notificationEnum === 'BIRTHDAY') data = { name: 'Notifications' };
      if (n.notificationEnum === 'POLICY_EXPIRED') data = { name: 'SinglePolicy', params: { policyNo: n.policyNumber } };

      await axios.put(`/customer/notification/app/read/${n.notificationId}`)
        .then(() => {
          this.$router.push(data);
        });
    },
  },
  metaInfo: {
    title: 'Notifications',
  },
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  & > * {
    transition-duration: 100ms;
    transition-property: opacity, transform;
    transition-timing-function: cubic-bezier(.6,.15,.35,.8);
  }

}

$delay: 60ms;
$delayStep: 60ms;

.fade-enter,
.fade-leave-to {
  & > * {
    opacity: 0;
    transform: translateY(40px);
  }
}
.fade-enter-active {
  & > * {
    &:nth-child(2) {
      transition-delay: $delay;
    }
    &:nth-child(3) {
      transition-delay: $delay + $delayStep;
    }
  }
}
.fade-leave-active {
  & > * {
    &:nth-child(1) {
      transition-delay: $delay + $delayStep;
    }
    &:nth-child(2) {
      transition-delay: $delay;
    }
  }
}
</style>
